import type React from "react";
import {
    Box,
    BoxSeam,
    CalendarEvent,
    Cart3,
    ChatDots,
    ClockHistory,
    Diagram3,
    Folder2Open,
    GeoAlt,
    Globe,
    GraphUpArrow,
    JournalText,
    LifePreserver,
    Megaphone,
    Mortarboard,
    PatchCheck,
    People,
    PersonPlus,
    Plug,
    Receipt,
    Robot,
    ShieldCheck,
    Shop,
    Tools,
    Trophy,
} from "react-bootstrap-icons";

export type IconComp = React.ComponentType<{size?: number; className?: string; color?: string}>;

/* Per-app icon, hand-picked from react-bootstrap-icons so each app reads at a
 * glance. Keep entries in slug-alphabetical order. Consumed by both the /apps
 * page and the homepage AllAppsGrid section. */
export const APP_ICONS: Record<string, IconComp> = {
    "ai-agent": Robot,
    analytics: GraphUpArrow,
    approvals: PatchCheck,
    attendance: ClockHistory,
    campaigns: Megaphone,
    chat: ChatDots,
    connector: Plug,
    content: JournalText,
    crm: People,
    "dealer-network": Diagram3,
    documents: Folder2Open,
    events: CalendarEvent,
    "field-sales": GeoAlt,
    "field-service": Tools,
    helpdesk: LifePreserver,
    inventory: BoxSeam,
    invoicing: Receipt,
    learning: Mortarboard,
    "online-store": Shop,
    recruitment: PersonPlus,
    sales: Cart3,
    "sales-incentives": Trophy,
    warranty: ShieldCheck,
    website: Globe,
};

export const FallbackIcon: IconComp = Box;
